<div class="thank-you-page-cart">
    <div class="thank-you-img d-flex justify-center">
      <img src="../../../../../../assets/images/thank-you.png" alt="" />
    </div>
    <div class="thank-you-page-wrapper">
      <span class="font-24 font-bold black display-block text-center nunito order-title">{{ 'Thank You' | translate }}</span>
      <span class="font-26 mt-3 display-block text-center px-48 order-info nunito"> 
        We have successfully sent your selected preferences list to <strong>{{ countryCode }} {{ mobileNumber }}</strong>
      </span>
  
      <div class="guest-cart-payment">
            <div class="order-id-cart d-flex align-item justify-content-between nunito">
              <span>Room Number</span>
              <span>{{ roomNumber }}</span>
            </div>
        
            <div class="order-id-cart d-flex align-item justify-content-between nunito" *ngIf="requestId">
              <span>Request ID</span>
              <span>{{ requestId }}</span>
            </div>
            <div class="order-id-cart d-flex align-item justify-content-between nunito">
              <span>Requested Time & Date</span>
              <span>{{ currentTime }}</span>
            </div>
      </div>
      
      <button class="backRestaurant nunito pointer" (click)="goHome()">{{ 'Go back to home' | translate }}</button>
    </div>
</div>